import { loadingIndicator } from './types';

const showLoadingIndicator = (payload) => ({
  type: loadingIndicator.SHOW_LOADING_INDICATOR,
  payload
});

export { showLoadingIndicator };
